import axios from 'axios';
import store from '@/store/index';
import domain_config from '@/api/domain-config';
import { emitHttpError } from '@/utils/http-error-events';

function getBaseURL() {
    const envBaseURL = process.env.VUE_APP_API_BASE_URL;
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (isDevelopment) {
        console.log('Development mode');
        return '/api/v1'; // use proxy in vue.config.js
    }

    const hostname = window.location.hostname;

    if (domain_config[hostname]) {
        return domain_config[hostname];
    }

    const subdomain = hostname.split('.')[0];
    if (subdomain && subdomain !== 'localhost' && subdomain !== '127.0.0.1') {
        return envBaseURL.replace('api', `${subdomain}.api`);
    }

    return envBaseURL;
}

const baseURL = getBaseURL();

const apiClient = axios.create({
    baseURL: baseURL,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
});

const markHandledHttpError = error => {
    error.isGlobalHttpErrorHandled = true;
    return error;
};

apiClient.interceptors.request.use(
    config => {
        const token = store.state.auth.token;
        if (token) {
            if (token && !config.skipAuthorization) {
                config.headers.Authorization = `Bearer ${token}`;
            } else {
                delete config.headers.Authorization;
            }
        }
        return config;
    },
    error => {
        console.error('Request was not sent');
        return Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        const { config, response } = error;

        if (config?.skipAuthHandling) {
            return Promise.reject(error);
        }

        if (config?.skipErrorPopup && response?.status !== 402) {
            return Promise.reject(error);
        }

        if (response) {
            if (response.status === 403 && config?.skip403Handling) {
                return Promise.reject(error);
            } else if (response.status === 402 && config?.skip402Handling) {
                return Promise.reject(error);
            }

            if (response.status === 402) {
                markHandledHttpError(error);
            }

            emitHttpError({
                status: response.status,
                message: response.data?.error,
                path: config?.url,
                method: config?.method,
            });
        } else {
            console.error('Network or server error', error);
            emitHttpError({
                status: null,
                message: null,
                path: config?.url,
                method: config?.method,
            });
        }

        return Promise.reject(error);
    }
);
export default apiClient;
